import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Select from "react-select";
import toast from "react-hot-toast";
import makeAnimated from "react-select/animated";
import { getCookie } from "../components/Cookie.jsx";
import { MultiSelect } from "react-multi-select-component";
import AlertConfirmationDialog from "../components/AlertConfirmationDialog.jsx";

const AlertDialog = ({
  open,
  onClose,
  title,
  description,
  onConfirm,
  type,
  accessGroupData,
  appendData,
  data,
}) => {
  const animatedComponents = makeAnimated();
  const [options, setOptions] = useState([]);
  const [roleName, setRoleName] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [errors, setErrors] = useState({ roleName: "", select: "" });
  const TOKEN = getCookie("sqa_token");
  const [alertOpen, setAlertOpen] = useState(false);

  useEffect(() => {
    const transformedOptions = data?.map((item) => ({
      value: item._id,
      label: item.dname,
    }));
    setOptions(transformedOptions);
  }, [data]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { roleName: "", select: "" };

    if (!roleName.trim()) {
      newErrors.roleName = "User Role Name is required.";
      isValid = false;
    }

    if (selectedOptions.length === 0) {
      newErrors.select = "Please select at least one dashboard.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const resetState = () => {
    setRoleName("");
    setSelectedOptions([]);
    setErrors({});
  };

  const createRole = async () => {
    const dashboardData = selectedOptions.map((selectedOption) => {
      const dashboard = data.find((item) => item._id === selectedOption.value);
      return {
        [dashboard._id]: dashboard.dashboard_fn.map((fn) => fn._id),
      };
    });

    const payload = {
      role_name: roleName,
      dashboard_data: dashboardData,
    };

    try {
      const response = await fetch("/sqa/api/create_roles/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.success) {
        toast.success(data.message);
        appendData(data?.result);
        onClose();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Error submitting data: ", error);
    }
  };

  const handleRoleNameChange = (e) => {
    setRoleName(e.target.value);
    if (errors.roleName) {
      setErrors((prevErrors) => ({ ...prevErrors, roleName: "" }));
    }
  };

  const handleSelectChange = (selected) => {
    setSelectedOptions(selected);
    if (errors.select) {
      setErrors((prevErrors) => ({ ...prevErrors, select: "" }));
    }
  };

  const handleAlertOpen = () => {
    if (!validateForm()) {
      return;
    }
    setAlertOpen(true);
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleConfirm = () => {
    createRole();
  };

  const handleCancel = () => {};

  const inputStyle =
    "py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-0 disabled:opacity-50 disabled:pointer-events-none";

  // const selectStyles = {
  //   control: (base) => ({
  //     ...base,
  //     minHeight: "50px", // Set the minimum height for the select control
  //     overflowY: "auto",
  //   }),

  //   menuPortal: (base) => ({
  //     ...base,
  //     zIndex: 9999,
  //   }),
  // };
  return (
    <>
      {type === "alert" && (
        <Dialog
          open={open}
          onClose={onClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            style: { position: "absolute", top: "20px", margin: 0 },
          }}
        >
          <DialogTitle id="alert-dialog-title">
            {title}
            <IconButton
              aria-label="close"
              onClick={onClose}
              style={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {description}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <Button onClick={onConfirm} autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {type === "dialog" && (
        <Dialog
          open={open}
          onClose={() => {
            onClose();
            resetState();
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
          maxWidth="md"
          PaperProps={{
            style: {
              width: "80dvw",
              position: "absolute",
              top: "20px",
              margin: 0,
            },
          }}
        >
          <DialogTitle id="alert-dialog-title">
            {title}
            <IconButton
              aria-label="close"
              onClick={() => {
                onClose();
                resetState();
              }}
              style={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent style={{ maxHeight: "70vh", overflowY: "auto" }}>
            <div className="grid grid-cols-2 md:grid-cols-2 gap-4">
              <div>
                <label
                  htmlFor="roleName"
                  className="block text-sm font-medium text-gray-700 font-semibold pb-2"
                >
                  User Role Name<span className="text-red-500">*</span>
                </label>
                <input
                  id="roleName"
                  type="text"
                  placeholder="Enter User Role Name"
                  className={inputStyle}
                  style={{ height: "40px" }}
                  value={roleName}
                  onChange={handleRoleNameChange}
                />
                {errors.roleName && (
                  <p className="text-red-500 text-sm">{errors.roleName}</p>
                )}
              </div>
              <div>
                <label
                  htmlFor="dashboardSelect"
                  className="block text-sm font-medium text-gray-700 pb-2 font-semibold"
                >
                  Select Dashboard<span className="text-red-500">*</span>
                </label>
                <MultiSelect
                  options={options}
                  value={selectedOptions}
                  onChange={handleSelectChange}
                  labelledBy="Select a Dashboard"
                  className="my-custom-multi-select dropdown-above-modal "
                  overrideStrings={{
                    selectSomeItems: "Select Dasboards...", // Custom placeholder text
                    allItemsAreSelected: "All Dashboards are selected", // Custom text when all items are selected
                  }}
                />

                {errors.select && (
                  <p className="text-red-500 text-sm">{errors.select}</p>
                )}
              </div>
            </div>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
            <button
              // onClick={createRole}
              onClick={handleAlertOpen}
              className="bg-[#4880FF] text-white px-3 py-2 rounded-md hover:bg-blue-600 mb-2"
            >
              Add Role
            </button>
          </DialogActions>
        </Dialog>
      )}
      <AlertConfirmationDialog
        alertOpen={alertOpen}
        handleAlertClose={handleAlertClose}
        title="Confirmation"
        content="Are you sure you want to create the role?"
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        confirmText="Confirm"
        cancelText="Cancel"
      />
    </>
  );
};

export default AlertDialog;
